module.exports = __webpack_public_path__ + "static/media/dsp.31c47841.jpeg";